const maReadyRouter = [{
        path: "/maReady01",
        component: () =>
            import ("@/app/register/views/material/maReady.vue"),
        meta: {
            title: "物资供应商申请合作准备信息"
        },

        children: [{
                path: "/maReady01",
                component: () =>
                    import ("@/app/register/views/material/registerStep/maReady01.vue"),
                meta: {
                    title: "物资供应商申请合作准备信息"
                }
            },
            {
                path: "/maReady02",
                component: () =>
                    import ("@/app/register/views/material/maFastReg/maReady02.vue"),
                meta: {
                    title: "入网供应商须知"
                }
            },
            {
                path: "/maPerfectInfo/moralAgreement",
                component: () =>
                    import (
                        "@/app/register/views/material/maPerfectInfo/moralAgreement.vue"
                    ),
                meta: {
                    title: "恪守商业道德协议"
                }
            },
            {
                path: "/maPerfectInfo/applyUsername",
                component: () =>
                    import (
                        "@/app/register/views/material/maPerfectInfo/applyUsername.vue"
                    ),
                meta: {
                    title: "申请用户名"
                }
            },
            {
                path: "/maPerfectInfo/basicInformation",
                component: () =>
                    import (
                        "@/app/register/views/material/maPerfectInfo/basicInformation.vue"
                    ),
                meta: {
                    title: "供应商基本信息"
                }
            },
            {
                path: "/maPerfectInfo/contactInformation",
                component: () =>
                    import (
                        "@/app/register/views/material/maPerfectInfo/contactInformation.vue"
                    ),
                meta: {
                    title: "联系人信息"
                }
            },
            {
                path: "/maPerfectInfo/productInformation",
                component: () =>
                    import (
                        "@/app/register/views/material/maPerfectInfo/productInformation.vue"
                    ),
                meta: {
                    title: "产品信息"
                }
            },
            {
                path: "/maPerfectInfo/financialInformation",
                component: () =>
                    import (
                        "@/app/register/views/material/maPerfectInfo/financialInformation.vue"
                    ),
                meta: {
                    title: "财务信息"
                }
            },
            {
                path: "/maPerfectInfo/historyCooperation",
                component: () =>
                    import (
                        "@/app/register/views/material/maPerfectInfo/historyCooperation.vue"
                    ),
                meta: {
                    title: "历史合作业绩"
                }
            },
            {
                path: "/maPerfectInfo/qualificationDocuments",
                component: () =>
                    import (
                        "@/app/register/views/material/maPerfectInfo/qualificationDocuments.vue"
                    ),
                meta: {
                    title: "资质文件"
                }
            }
        ]
    },
    {
        path: "/regView/mobileValidate",
        component: () =>
            import ("@/app/register/views/regView/mobileValidate.vue"),
        meta: {
            title: "手机号认证"
        }
    },
    {
        path: '/regView/supRegDetail',
        component: () =>
            import ('@/app/register/views/regView/supRegDetail.vue'),
        meta: {
            title: '注册详情页(国内)'
        }
    },
    {
        path: '/regView/foreignSupRegDetail',
        component: () =>
            import ('@/app/register/views/regView/foreignSupRegDetail.vue'),
        meta: {
            title: '注册详情页(国外)'
        }
    },
];

export default maReadyRouter;